import axios from 'axios';

export const createAxios = ({baseUrl}) =>
  axios.create({
    baseURL: baseUrl
  });
